import "./authorized_signers.css"
import review_logo from "../../../assets/logo.svg";
import personal_img from "../../../assets/pers_img.png";
import Logout from "../../logout/Logout";
import React, {useState} from "react";
import Form from "react-bootstrap/Form";
import {useTranslation} from "react-i18next";
import {Link, useNavigate} from "react-router-dom";
import {connect} from "react-redux";
import {setAuthInfo} from "../../../redux/auth_singer_store";
import axios from "axios";

const HOST = `${process.env.REACT_APP_API_URL}/api/accounts/step32/`
function AuthorizedSignersInfo({authData, setAuthInfo, appData}) {

    const {t} = useTranslation()
    const navigate = useNavigate()

    const [authErrors, setAuthErrors] = useState([{
        auth_title: '',
        auth_first_name: '',
        auth_middle_name: '',
        auth_last_name: '',
        auth_entity_role: ''
    }]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        let errors = []
        authData.forEach(e => {
            errors.push({
                auth_title: '',
                auth_first_name: '',
                auth_middle_name: '',
                auth_last_name: '',
                auth_entity_role: ''
            })
        })

        let isValid = true;
        authData.forEach((data, i) => {
            if (!data.auth_title) {
                const errors2 = errors.map((e, index) => {
                    if (i === index) {
                        return {
                            ...e,
                            auth_title: t('errors.required_field')
                        }
                    }
                    return e
                })
                errors = [...errors2]

                isValid = false;
            }

            if (!data.auth_first_name) {
                const errors2 = errors.map((e, index) => {
                    if (i === index) {
                        return {
                            ...e,
                            auth_first_name: t('errors.required_field'),
                        }
                    }
                    return e
                })
                errors = [...errors2]

                isValid = false;
            }

            if (!data.auth_last_name) {
                const errors2 = errors.map((e, index) => {
                    if (i === index) {
                        return {
                            ...e,
                            auth_last_name: t('errors.required_field'),
                        }
                    }
                    return e
                })
                errors = [...errors2]

                isValid = false;
            }

            if (!data.auth_entity_role) {
                const errors2 = errors.map((e, index) => {
                    if (i === index) {
                        return {
                            ...e,
                            auth_entity_role: t('errors.required_field'),
                        }
                    }
                    return e
                })

                errors = [...errors2]

                isValid = false;
            }
        })

        setAuthErrors([...errors])

        if (isValid) {
            await authApp()
            navigate('/account')
        }
    };

    const authApp = async () => {
        const URL = HOST + appData.app_id

        await axios.put(URL, {
            ...authData[0],
            account_type: appData.account_type
        }, {
            headers: {
                "Access-Control-Allow-Origin": "*",
                'Accept': 'application/json, text/plain, */*',
                'Content-Type': 'application/json'
            }
        })
    }
    const handleInputChange = (e, index) => {
        const {name, value} = e.target;
        const result = authData.map((el, i) => {
            if (index === i) {
                return {
                    ...el,
                    [name]: value
                }
            }
            return el
        })
        setAuthInfo(result);
    };

    return (
        <div className="auth_info">
            <div className="auth_info_left_side">
                <img src={review_logo} alt=""/>
                <img style={{paddingTop: "12%"}} src={personal_img} alt=""/>
            </div>
            <div className="auth_info_right_side">
                <Logout/>
                <div>
                    <p className="auth_info_heading">{t('specialty.for_accounts')}</p>
                </div>
                <form onSubmit={handleSubmit}>
                    {(authData || []).map((authData, index) => (
                        <>
                            <div className="auth_info_inputs">
                                <div className="auth_info_input_error">
                                    <Form.Select aria-label="Default select example"
                                                 name="auth_title"
                                                 value={authData.auth_title}
                                                 onChange={(e) => handleInputChange(e, index)}
                                    >
                                        <option>{t('personal.title')}</option>
                                        <option value="Mr.">{t('personal.mr')}</option>
                                        <option value="Ms.">{t('personal.ms')}</option>
                                        <option value="Mrs.">{t('personal.mrs')}</option>
                                        <option value="Dr.">{t('personal.dr')}</option>
                                    </Form.Select>
                                    {authErrors[index]?.auth_title &&
                                        <p className="error">{authErrors[index].auth_title}</p>}
                                </div>
                                <div className="auth_info_input_error">
                                    <input className="auth_info_input" placeholder={t('personal.first_name')}
                                           type="text"
                                           name="auth_first_name"
                                           value={authData.auth_first_name}
                                           onChange={(e) => handleInputChange(e, index)}
                                    />
                                    {authErrors[index]?.auth_first_name &&
                                        <p className="error">{authErrors[index].auth_first_name}</p>}
                                </div>
                                <div className="auth_info_input_error">
                                    <input className="auth_info_input" placeholder={t('specialty.middle_name')}
                                           type="text"
                                           name="auth_middle_name"
                                           value={authData.auth_middle_name}
                                           onChange={(e) => handleInputChange(e, index)}
                                    />
                                </div>
                                <div className="auth_info_input_error">
                                    <input className="auth_info_input" placeholder={t('personal.last_name')}
                                           type="text"
                                           name="auth_last_name"
                                           value={authData.auth_last_name}
                                           onChange={(e) => handleInputChange(e, index)}
                                    />
                                    {authErrors[index]?.auth_last_name &&
                                        <p className="error">{authErrors[index].auth_last_name}</p>}
                                </div>
                                <div className="auth_input_full_error">
                                    <Form.Select aria-label="Default select example"
                                                 name="auth_entity_role"
                                                 value={authData.auth_entity_role}
                                                 onChange={(e) => handleInputChange(e, index)}
                                    >
                                        <option>{t('specialty.entity_role')}</option>
                                        <option value="President">{t('specialty.president')}</option>
                                        <option value="Treasurer">{t('specialty.treasurer')}</option>
                                        <option value="Vice President">{t('specialty.vice_president')}</option>
                                        <option value="Secretary">{t('specialty.secretary')}</option>
                                    </Form.Select>
                                    {authErrors[index]?.auth_entity_role &&
                                        <p className="error">{authErrors[index].auth_entity_role}</p>}
                                </div>
                            </div>
                            {/*<div className="auth_check">*/}
                            {/*    <Form.Check aria-label="option 1"*/}
                            {/*                onChange={(e) => handleCheckboxChange(e, index)}*/}
                            {/*                checked={authData.checked}*/}
                            {/*    />*/}
                            {/*    <span className="checkbox_text">{t('specialty.add_signer')}</span>*/}
                            {/*</div>*/}
                        </>
                    ))}

                    <div className="auth_btn">
                        <Link style={{textDecoration: "none"}} to="/affiliation">
                            <button className="auth_back_btn">{t('back_btn')}</button>
                        </Link>
                        <button className="auth_continue_btn" type="submit">{t('next_btn')}</button>
                    </div>
                </form>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    authData: state.authData,
    appData: state.appData
});

const mapDispatchToProps = {
    setAuthInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthorizedSignersInfo);